import React from 'react';
import styles from './FeatureItem.module.css';

const FeatureItem = ({ tag = 'Feature', title, subtitle, description }) => {
  return (
    <div className={styles.feature}>
      <div className={styles.feature__content}>
        <div className={styles.feature__tagline}>
          <span className={styles['feature__tagline-dot']}></span>
          <span className={styles['feature__tagline-text']}>{tag}</span>
        </div>
        <div className={styles.feature__headings}>
          <h2 className={styles.feature__title}>{title}</h2>
          <div className={styles.feature__text}>
            <p className={styles.feature__subtitle}>{subtitle}</p>
            <p className={styles.feature__description}>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureItem;
